export default __webpack_public_path__ + "static/media/โปรที่3BT86.9002da3f.png";